import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
@Injectable()
export abstract class LorenBaseEndpointsService {

    protected getApiServerUrl() {
        return environment.apiServerUrl;
    }
}
